import Vue from 'vue'

import _Profile from './Profile'

export const Profile = Vue.component('profile', _Profile);

